export enum AnalyticsJourneyKey {
  AppLoad = 'app-load',
  ViewPackage = 'view-package',
  ChangePackage = 'change-package',
  ReconnectPackage = 'reconnect-package',
  DisconnectPackage = 'disconnect-package',
  AccountDashboard = 'account-dashboard',
  ProductSubscription = 'product-subscription',
  OnDemandService = 'on-demand-service',
  ProductHardware = 'product-hardware',
  ProductInternet = 'product-internet',
  ProductInsurance = 'product-insurance',
  ProductExtraStream = 'product-extra-stream',
  DstvActivate = 'dstv-activate',
  FixError = 'fix-error',
  SubscriptionPriceLock = 'subscription-price-lock',
  UpdatePaymentMethod = 'update-payment-method',
  SwitchToContract = 'switch-to-contract',
  StreamRenewContract = 'renew_contract',
  Rewards = 'rewards',
  FuneralPolicy = 'funeral-policy',
}

export enum CommonStep {
  StartJourney,
  EndJourney,
  JourneyFailed,
}

export enum AppLoadStep {
  Authorized = 'Authorized',
  Authenticated = 'Authenticated',
  LoadSubscriptions = 'LoadSubscriptions',
  LoadAccountDetails = 'LoadAccountDetails',
}

export enum ReconnectPackageStep {
  LoadEligiblePackages = 'LoadEligiblePackages',
  GenerateQuote = 'GenerateQuote',
  AcceptQuote = 'AcceptQuote',
  RejectQuote = 'RejectQuote',
}

export enum DisconnectPackageStep {
  LoadEligiblePackages = 'LoadEligiblePackages',
  SubmitSurvey = 'SubmitSurvey',
  CompleteDisconnectRequest = 'CompleteDisconnectRequest',
  CancelDisconnectRequest = 'CancelDisconnectRequest',
}

export enum AnalyticsEventJourneyKey {
  BeginCheckout = 'begin_checkout',
  AddPaymentInfo = 'add_payment_info',
  Purchase = 'purchase',
  PurchaseFailure = 'payment_failure',
  UnbundledPurchase = 'unbundled_purchase',
  SelfServiceProductSwitcher = 'selfservice_product_switcher',
  BundleServiceSuccess = 'bundle_service_success',
  BundleServiceFailure = 'bundle_service_failure',
  StreamRenewContractSuccess = 'renew_contract_success',
  StreamRenewContractFailure = 'renew_contract_failure',
  ContractSuccess = 'contract_service_success',
  ContractFailure = 'contract_service_failure',
  BundleAddOnServiceFailure = 'bundle_addon_service_failure',
  BundleAddOnServiceSuccess = 'bundle_addon_service_success',
  BundleAddonSwitcher = 'bunndle_addon_switcher',
  RentMovies = 'rent_movies',
  DecoderServiceSuccess = 'decoder_service_success',
  InternetServiceSuccess = 'internet_service_success',
  InternetServiceFailure = 'internet_service_failure',
  FSPServiceSuccess = 'fsp_service_success',
  FSPServiceFailure = 'fsp_service_failure',
  FreshdeskFormSubmitSuccess = 'form_submit_success',
  FreshdeskFormSubmitFailure = 'form_submit_failure',
  FixErrorSuccess = 'fix_error_success',
  FixErrorFailure = 'fix_error_failure',
  ExtraStreamSuccess = 'extra_stream_success',
  ExtraStreamFailure = 'extra_stream_failure',
  SubscriptionPriceLockPurchase = 'subscription_price_lock_purchase',
  SubscriptionPriceLockSuccess = 'subscription_price_lock_success',
  SubscriptionPriceLockFailure = 'subscription_price_lock_failure',
  DebitOrderSuccess = 'debt_order_success',
  DebitOrderFailure = 'debit_order_failure',
  CashSuccess = 'cash_success',
  CashFailure = 'cash_failure',
  CreditCardSuccess = 'credit_card_success',
  CreditCardFailure = 'credit_card_failure',
  RewardServiceSuccess = 'reward_service_success',
  RewardServiceFailure = 'reward_service_failure',
  FuneralPolicyActivationSuccess = 'funeral_policy_activation_success',
  FuneralPolicyActivationFailure = 'funeral_policy_activation_failure',
}

export enum UtmTypes {
  Source = 'utm_source',
  Medium = 'utm_medium',
  Campaign = 'utm_campaign',
  Content = 'utm_content',
  Term = 'utm_term',
  GoogleAnalytics = '_ga',
  GoogleLink = '_gl',
}
